export const parseOffsetByIANATimezone = (timezone: string): string => {
  const locale = 'en-US';
  const usRe = /(\d+).(\d+).(\d+),?\s+(\d+).(\d+)(.(\d+))?/;

  const format: Intl.DateTimeFormatOptions = {
    timeZone: 'UTC',
    hour12: false,
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
  };

  const utcF = new Intl.DateTimeFormat(locale, format);

  function parseDate(dateStr: string): number[] {
    dateStr = dateStr.replace(/[\u200E\u200F]/g, '');
    return [].slice.call(usRe.exec(dateStr), 1).map(Math.floor);
  }

  function diffMinutesCalc(d1: number[], d2: number[]) {
    const d1h = d1[3] === 24 ? 0 : d1[3];
    const d2h = d2[3] === 24 ? 0 : d2[3];
    let day = d1[1] - d2[1];
    const hour = d1h - d2h;
    const min = d1[4] - d2[4];

    if (day > 15) day = -1;
    if (day < -15) day = 1;

    return 60 * (24 * day + hour) + min;
  }

  format.timeZone = timezone;

  const locF = new Intl.DateTimeFormat(locale, format);
  const date = new Date();

  const diffMinutes = -diffMinutesCalc(
    parseDate(utcF.format(date)),
    parseDate(locF.format(date)),
  );

  const diffHours = Math.floor(diffMinutes / 60);

  const diffMinutesLeft = diffMinutes % 60;

  return `${
    diffHours >= 0 ? '+' : ''
  }${diffHours.toString().padStart(2, '0')}:${diffMinutesLeft.toString().padStart(2, '0')}`;
};

export const getTimeInLocalTimezone = (time: string) => {
  const date = new Date(time);

  return date.toLocaleString('ru-RU');
};

export const getRelativeDatetime = (date: string) => {
  const dateObject = new Date(date);

  const secondsDiff = Math.round((dateObject.getTime() - Date.now()) / 1000);

  const unitsInSec = [60, 3600, 86400, 86400 * 30, 86400 * 365, Infinity];

  const unitStrings: Intl.RelativeTimeFormatUnit[] = [
    'second',
    'minute',
    'hour',
    'day',
    'month',
    'year',
  ];

  const unitIndex = unitsInSec.findIndex(
    (cutoff) => cutoff > Math.abs(secondsDiff),
  );

  const divisor = unitIndex ? unitsInSec[unitIndex - 1] : 1;

  const rtf = new Intl.RelativeTimeFormat('ru', {numeric: 'always'});

  return rtf.format(Math.floor(secondsDiff / divisor), unitStrings[unitIndex]);
};
